import React from 'react';
import * as FPT from '../utility/fpt';
import TemplateData from '../utility/getTemplateData';
import { localsMessages } from '../utility/getTemplateData';
import { isInContext, closeWindow } from '../utility/inContextDonation';

const messages = localsMessages('common/cancelAndReturn');

class CancelAndReturn extends React.Component {
  constructor() {
    super();
    const { label: { return: returnLabel = '' } = {} } = messages || {};
    this.state = {
      returnLabel: returnLabel,
      displayMe: TemplateData.charityCancelUrl ? true : false,
    };
  }

  handleCancel = () => {
    FPT.trackLinkClick('cancel');

    if (isInContext()) {
      closeWindow();
      return;
    }

    let cancelurl = TemplateData.charityCancelUrl;
    if (cancelurl.indexOf('http') != 0 && cancelurl.indexOf('//') != 0) {
      cancelurl = '//' + cancelurl;
    }
    window.location.href = cancelurl;
  };

  render() {
    let labelreturn = this.state.returnLabel;
    labelreturn = labelreturn.replace('{orgName}', TemplateData.donationName);

    return (
      <div>
        {this.state.displayMe && (
          <div
            className="ppvx_col-sm-12 text-center pp_cancel_btn_wrapper"
            data-testid="cancel-and-return-container"
          >
            <a
              href="#"
              className="ppvx_link pp_cancel_btn"
              id="cancelReturnBtn"
              onClick={this.handleCancel}
              dangerouslySetInnerHTML={{ __html: labelreturn }}
            ></a>
          </div>
        )}
      </div>
    );
  }
}

export default CancelAndReturn;
